import { computed } from 'vue'
import { useQuery } from '@tanstack/vue-query'

import { locationsQuery, suppliersQuery } from '@/utilities/megalithQueries'

export function useLocations() {
  const { data: locations, isFetching: locationsIsFetching } = useQuery(locationsQuery())

  const { data: suppliers } = useQuery(suppliersQuery())

  const indexedSuppliers = computed(() => {
    return (
      suppliers.value?.reduce((accumulator, supplier) => {
        return { ...accumulator, [supplier.market]: supplier }
      }, {}) || {}
    )
  })

  const enhancedLocations = computed(
    () =>
      locations.value?.map(location => {
        const supplier = indexedSuppliers.value[location.market]

        return {
          ...location,
          formatted: {
            short: `${location.name}, ${location.address.city}`,
            long: `${location.name}, ${location.address.city}, ${location.address.country}`,
          },
          currencies: supplier?.availableCurrencies ?? ['USD'],
          defaultCurrency: supplier?.marketCurrency ?? 'USD',
        }
      }) || [],
  )
  return {
    enhancedLocations,
    locationsIsFetching,
  }
}
